import * as React from "react";
import Input from "../../Input-new/Input";
import SelectLender from "../../SelectLender/SelectLender";
import SelectAgent from "../../SelectAgent/SelectAgent";
import Dropdown from "../../Dropdown/Dropdown";
import Checkbox from "../../CheckboxNew/Checkbox";
import Textarea from "../../Textarea-new/Textarea";
import { splitTimestamp } from "../../../date-converter";
import UploadFiles from "./UploadFiles";
import { maxHscMembers } from "../../../consts/consts";
import moment from "moment";
import { addCommasToNumber } from "../../../utils";
import LoanNotes from "./LoanNotes";
import { getPeakApprovedEligibility } from "./PeakApprovedCheckbox";
import PeakAgreementForm from "./PeakAgreementForm";

const hscAgreementFile=[{
    label:'Peak Agreement',
    name:'HSC_AGREEMENT_FILE'
}]

const loanCommitmentFile=[{
    label:'Loan Commitment',
    name:'LOAN_COMMITMENT_FILE'
}]
export function priceToNumber(str) {
    if (typeof str === "string") {
        str = str.trim().replace(/\$|,/g, "");
        const num = Number(str);
        if (str && num === num) {
            // !isNaN
            return num;
        }
    }
    return false;
}

const closingStatementFile=[{
    label:'Closing Statement',
    name:'CLOSING_STATEMENT_FILE'
}]

const Loan = ({isTeamMember, data, displayedAgentsNr, handleChangeInput, handleChangeDropdown, handleInputBlur, addHscMember, handleChangeFile, openHscPayments, hscTeamMembers, addNewItem, newLender, newAgent, viewMode, deleted, loanNotes, currentUser, onAddLoanNote, onDeleteLoanNote, onEditLoanNote, lenderContactOverride, loanQuotes}) => {
    const { canToggleApproved } = getPeakApprovedEligibility({ data, isTeamMember, viewMode });
    const isUncheckable = !canToggleApproved;
    const {timestampDate, timestampHour} = splitTimestamp(data.HSC_APPROVED_TIMESTAMP);
    const hscTotalFee = data.HSC_TOTAL_FEE ? priceToNumber(data.HSC_TOTAL_FEE) : 0;
    const referral = data.REFERRAL ? priceToNumber(data.REFERRAL) : 0;
    const credits = data.CREDITS_AT_CLOSING ? priceToNumber(data.CREDITS_AT_CLOSING) : 0;
    const bankBonus = data.BANK_BONUS ? priceToNumber(data.BANK_BONUS) : 0;
    const loanAmount = data.LOAN_AMOUNT ? priceToNumber(String(data.LOAN_AMOUNT)) : 0;
    const peakFeePercent = parseFloat(String(data.HSC_FEE_PERCENTAGE == null ? '' : data.HSC_FEE_PERCENTAGE).replace(/[%,]/g, ''));
    const peakFeeWarning = loanAmount && !(peakFeePercent > 0)
        ? (peakFeePercent === 0 ? 'Peak Fee Percentage is 0%' : 'Add a Peak Fee Percentage to calculate this fee')
        : null;
    const hscInvoiceImageURL = 'https://s3-us-west-1.amazonaws.com/arcfusion-env-01-open/arcfusion/skydata/arc11a015/media/apps/arcimedes/v0/10ae4ac42c8b55fedab686b92b8abb6aa22af74a8076eedff868c9068c003b272fc39588a86c200563a25952663d5ce4670090de0ae298c5f2d0d966a0c1129b_HSC-Invoice_Wire_Instructions.jpg?w=120&h=100';
    const peakCapitalLogo = 'https://s3-us-west-1.amazonaws.com/arcfusion-env-01-open/arcfusion/skydata/arc11a015/media/apps/arcimedes/v0/8d3834445d7d67a66ca3ca789ca81a7e1e7907a8a07459ee19ee6936f41e453809419dccabbb8bd152ff71e1584d6bb58c990f398e8470ca6d4b4e8a31c862e2_PeakCapitalLogoDark.png'
    const todaysDate = moment(new Date()).format('dddd, MMMM DD, YYYY');
    const [isPrintingHscInvoice, setIsPrintingHscInvoice] = React.useState(false);

    React.useEffect(() => {
        if (isPrintingHscInvoice) {
            const originalTitle = document.title;
            document.title = 'Peak Capital Invoice and Wire Instructions';
            window.print();
            document.title = originalTitle;
            setIsPrintingHscInvoice(false);
        }
    }, [isPrintingHscInvoice]);

    React.useEffect(() => {
        // !important + first-in-head: the bundled PrintBooklet.scss ships a global
        // `@page { size: 11in 8.5in !important }` (landscape) that leaks into every
        // route. Among competing !important @page sizes Chromium honors the FIRST in
        // document order (see PrintContinuum.js), so this portrait rule must sit
        // before the bundle; the last-in-head copy covers spec-correct engines
        // where the last one wins.
        const css = `
        @media print {
            @page {
                size: portrait !important;
                margin: 0 !important;
            }
        }`;
        const first = document.createElement('style');
        first.innerHTML = css;
        const last = document.createElement('style');
        last.innerHTML = css;
        document.head.insertBefore(first, document.head.firstChild);
        document.head.appendChild(last);
        return () => {
            document.head.removeChild(first);
            document.head.removeChild(last);
        };
    }, []);

    function printHscInvoice(event){
        event.preventDefault();
        setIsPrintingHscInvoice(true);
    }

    return (
        <React.Fragment>
        <div className="print-HSC-Invoice" style={!isPrintingHscInvoice ? { display: 'none' } : {}}>
            {/* <img src={hscInvoiceImageURL}/>
            <div className="hsc-content HSC-date">{todaysDate}</div>
            <div className="hsc-content HSC-Property-Address">
                {data.NAME}<br/>
                {data.ADDRESS}<br/>
                {data.CITY}, {data.STATE} {data.ZIP}
            </div>
            <div className="hsc-content HSC-Loan-Amount">
                {data.LOAN_AMOUNT && `$${data.LOAN_AMOUNT}`}
            </div>
            <div className="hsc-content HSC-Fee-Percentage">
                {data.HSC_FEE_PERCENTAGE && `${Number(data.HSC_FEE_PERCENTAGE).toFixed(2)}%`}
            </div>
            <div className="hsc-content HSC-Total-Fee">
            {data.HSC_TOTAL_FEE && `$${addCommasToNumber(Number(data.HSC_TOTAL_FEE.replace(/,/g, "")).toFixed(2))}`}
            </div> */}
            <div className="print-HSC-Invoice-content">
                <img src={peakCapitalLogo} alt="Peak Capital Logo" style={{width: '320px', display: 'block', margin: '0 auto'}} />
                <h6 className="invoice-date">{todaysDate}</h6>
                <h1>Invoice</h1>
                <table className="invoice-table">
                    <tbody>
                        <tr>
                            <td>Due Date:</td>
                            <td>Upon Closing & Funding</td>
                        </tr>
                        <tr>
                            <td>Property:</td>
                            <td>{data.NAME} &ndash; {data.CITY}, {data.STATE}</td>
                        </tr>
                        <tr>
                            <td>Peak Capital Fee:</td>
                            <td>{data.HSC_TOTAL_FEE && `$${addCommasToNumber(Number(data.HSC_TOTAL_FEE.replace(/,/g, "")).toFixed(2))}`}</td>
                        </tr>
                    </tbody>
                </table>
                <h1>Wiring Instructions</h1>
                <table>
                    <tbody>
                        <tr>
                            <td>Bank:</td>
                            <td>	JPMorgan Chase  
                                <br />383 Madison Ave
                                <br />New York, NY 10017
                            </td>
                        </tr>
                        <tr>
                            <td>Routing Number:</td>
                            <td>021000021</td>
                        </tr>
                        <tr>
                            <td>Account Number:</td>
                            <td>2906690782</td>
                        </tr>
                        <tr>
                            <td>Beneficiary:</td>
                            <td>Peak Capital LLC</td>
                        </tr>
                        <tr>
                            <td>Reference:</td>
                            <td><span>{data.NAME} &ndash; {data.CITY}, {data.STATE}</span></td>
                        </tr>
                    </tbody>
                </table>
                <span className="invoice-footer">14755 Preston Rd, Suite 440 Dallas, TX 75254 <br />(972) 910-2155</span>
            </div>
        </div>
        <div className={data.OTHER_FINANCING ? 'Loan other-financing' : 'Loan'}>
            <div className="Loan_column">
                <SelectLender
                    className="Loan_column_item"
                    isFromProperty
                    value={data.LENDER_ID}
                    valueKey="LENDER_ID"
                    label="Lender"
                    data={data}
                    handleParentChange={handleChangeDropdown}
                    withAddNew
                    addNewItem={addNewItem}
                    viewMode={viewMode}
                    deleted={deleted}
                    newLender={newLender}
                    withContact
                    contactOverride={lenderContactOverride} />
                <Dropdown
                    className="Loan_column_item"
                    data={data}
                    isFromProperty
                    optionsType="loan"
                    value={data.LOAN_TYPE}
                    valueKey="LOAN_TYPE"
                    label="Loan Type"
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted} />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="integer"
                    name="LOAN_AMOUNT"
                    label="Loan Amount"
                    value={data.LOAN_AMOUNT}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isDollar />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="percent"
                    name="LTV"
                    label="LTV"
                    value={data.LTV}
                    disabled
                    tooltip='Loan Amount / Price'
                    tooltipPosition='down'
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    decimals={2} />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="percent"
                    name="INTEREST_RATE"
                    label="Interest Rate"
                    value={data.INTEREST_RATE}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    decimals={3} />
                <Input
                    className="Loan_column_item"
                    type="text"
                    name="AMORTIZATION"
                    label="Amortization"
                    value={data.AMORTIZATION}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted} />
                <LoanNotes
                    propertyId={data.ARCIMEDES_ROW_ID}
                    loanNotes={loanNotes}
                    currentUser={currentUser}
                    viewMode={viewMode}
                    onAddNote={onAddLoanNote}
                    onDeleteNote={onDeleteLoanNote}
                    onEditNote={onEditLoanNote}
                />
            </div>
            <div className="Loan_column">
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="number"
                    name="TERM"
                    label="Term"
                    value={data.TERM}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted} />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="number"
                    name="MATURITY"
                    label="Maturity"
                    value={data.MATURITY}
                    disabled
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted} />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="date"
                    name="MATURITY_DATE"
                    label="Maturity Date"
                    value={data.MATURITY_DATE}
                    disabled
                    tooltip={data.OTHER_FINANCING ? 'Close of Escrow + Term' : 'Loan Closing Date + Maturity'}
                    tooltipPosition='down'
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted} />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="integer"
                    name="ANNUAL_LOAN_PAYMENT"
                    label="Annual Loan Payment"
                    value={data.ANNUAL_LOAN_PAYMENT}
                    disabled
                    tooltip='-PMT(Interest Rate / 12, Amortization * 11.8, Loan Amount) * 12)'
                    tooltipPosition='down'
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isDollar />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="integer"
                    name="CASH_FLOW"
                    label="Cash Flow"
                    value={data.CASH_FLOW}
                    disabled
                    tooltip='NOI - Loan Payment'
                    tooltipPosition='down'
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isDollar />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="percent"
                    name="CASH_ON_CASH"
                    label="Cash on Cash"
                    value={data.CASH_ON_CASH}
                    disabled
                    tooltip='Cash Flow / Down Payment'
                    tooltipPosition='down'
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    decimals={2} />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="percent"
                    name="DSCR"
                    label="DSCR"
                    value={data.DSCR}
                    disabled
                    tooltip='NOI / Loan Payment'
                    tooltipPosition='down'
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    decimals={2} />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="text"
                    name="PREPAYMENT_PENALTY"
                    label="Prepayment Penalty"
                    value={data.PREPAYMENT_PENALTY}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted} />
            </div>
            {!data.OTHER_FINANCING &&
                <div className="Loan">
                    <div className="Loan_column">
                        <Input
                            className="Loan_column_item"
                            placeholder="MM/DD/YYYY"
                            type="text"
                            valueType="date"
                            name="HSC_LISTED_DATE"
                            label="Date Listed"
                            value={data.HSC_LISTED_DATE}
                            handleParentChange={handleChangeInput}
                            viewMode={viewMode}
                            deleted={deleted} />
                        <Input
                            className="Loan_column_item"
                            type="text"
                            valueType="number"
                            name="HSC_EXPIRATION_NO_OF_MONTHS"
                            label="# Of Months"
                            value={data.HSC_EXPIRATION_NO_OF_MONTHS}
                            handleParentChange={handleChangeInput}
                            viewMode={viewMode}
                            deleted={deleted} />
                        <Input
                            className="Loan_column_item"
                            placeholder="MM/DD/YYYY"
                            type="text"
                            valueType="date"
                            name="HSC_EXPIRATION_DATE"
                            label="Listing Expiration Date"
                            value={data.HSC_EXPIRATION_DATE}
                            handleParentChange={handleChangeInput}
                            viewMode={viewMode}
                            deleted={deleted} />
                        <UploadFiles
                            classNames="Loan_column_item"
                            data={data}
                            viewMode={viewMode}
                            deleted={deleted}
                            handleChangeFile={handleChangeFile}
                            maxFilesAmount={hscAgreementFile.length}
                            items={hscAgreementFile}
                            droppable
                            />
                        <Input
                            className="Loan_column_item"
                            type="text"
                            valueType="percent"
                            name="HSC_FEE_PERCENTAGE"
                            label="Peak Fee Percentage"
                            value={data.HSC_FEE_PERCENTAGE}
                            handleParentChange={handleChangeInput}
                            viewMode={viewMode}
                            deleted={deleted}
                            isDollar />

                        {hscTeamMembers.map((elem, index) => {
                            if (index < displayedAgentsNr)
                                return (
                                    <Dropdown
                                        key={'hsc-team-' + index}
                                        className="Loan_column_item hsc_dropdown"
                                        data={data}
                                        optionsType='team-members'
                                        optionLabelKey='NAME'
                                        value={elem}
                                        valueKey={`HSC_TEAM_MEMBER_${index + 1}`}
                                        percentKey={`HSC_TEAM_MEMBER_${index + 1}_PERCENT`}
                                        label={`Peak Team Member ${index + 1}`}
                                        viewMode={viewMode}
                                        handleParentChange={handleChangeDropdown}
                                        handleInputParentChange={handleChangeInput}
                                        deleted={deleted}
                                        optionKey={"EMAIL"}
                                        hasAgentPercent />);
                        })}
                        {!viewMode && displayedAgentsNr < maxHscMembers &&
                            <div className='Loan_column_item'>
                                <button className="button-new positive" onClick={addHscMember}>Add Member</button>
                            </div>}
                        <Input
                            className="Loan_column_item"
                            placeholder="MM/DD/YYYY"
                            type="text"
                            valueType="date"
                            name="LOAN_CLOSING_DATE"
                            label="Loan Closing Date"
                            value={data.LOAN_CLOSING_DATE}
                            handleParentChange={handleChangeInput}
                            handleParentBlur={handleInputBlur}
                            viewMode={viewMode}
                            deleted={deleted} />
                        <UploadFiles
                            classNames="Loan_column_item"
                            data={data}
                            viewMode={viewMode}
                            deleted={deleted}
                            handleChangeFile={handleChangeFile}
                            maxFilesAmount={loanCommitmentFile.length}
                            items={loanCommitmentFile}
                            />
                        <PeakAgreementForm
                            data={data}
                            loanQuotes={loanQuotes}
                            viewMode={viewMode}
                            deleted={deleted}
                            currentUser={currentUser} />
                    </div>
                    <div className="Loan_column">
                        <div className='total-fee-container'>
                            <Input
                                className="Loan_column_item"
                                disabled
                                tooltip='Loan Amount * HSC Fee Percentage'
                                tooltipPosition='down'
                                type="text"
                                valueType="float"
                                name="HSC_TOTAL_FEE"
                                label="Total Fee - Auto"
                                value={data.HSC_TOTAL_FEE}
                                handleParentChange={handleChangeInput}
                                viewMode={viewMode}
                                deleted={deleted}
                                decimals={2}
                                isDollar />
                            {peakFeeWarning && <span className='total-fee-warning' data-testid='peak-fee-warning'>{peakFeeWarning}</span>}
                        </div>
                        <div className='referral-container'>
                            <Input
                                className="Loan_column_item"
                                type="text"
                                valueType="float"
                                name="REFERRAL"
                                label="Referral"
                                value={data.REFERRAL}
                                handleParentChange={handleChangeInput}
                                viewMode={viewMode}
                                deleted={deleted}
                                decimals={2}
                                isDollar />
                            <Input
                                className="referral-percent"
                                type="text"
                                valueType="percent"
                                name="REFERRAL_PERCENT"
                                value={data.REFERRAL_PERCENT}
                                handleParentChange={handleChangeInput}
                                viewMode={viewMode}
                                deleted={deleted}
                                decimals={2} />
                        </div>
                        <SelectAgent
                            className="Loan_column_item"
                            isFromProperty
                            value={data.REFERRED_BY_ID}
                            valueKey="REFERRED_BY_ID"
                            typeKey="REFERRED_BY_TYPE"
                            label="Referred By"
                            data={data}
                            handleParentChange={handleChangeDropdown}
                            withAddNew
                            addNewItem={addNewItem}
                            newAgent={newAgent}
                            viewMode={viewMode}
                            deleted={deleted} />
                        <Input
                            className="Loan_column_item"
                            type="text"
                            valueType="float"
                            name="CREDITS_AT_CLOSING"
                            label="Credits @ Closing"
                            value={data.CREDITS_AT_CLOSING}
                            handleParentChange={handleChangeInput}
                            viewMode={viewMode}
                            deleted={deleted}
                            decimals={2}
                            isDollar />
                        <div className='referral-container'>
                            <Input
                                className="Loan_column_item"
                                type="text"
                                valueType="float"
                                name="BANK_BONUS"
                                label="Bank Bonus"
                                value={data.BANK_BONUS}
                                handleParentChange={handleChangeInput}
                                viewMode={viewMode}
                                deleted={deleted}
                                decimals={2}
                                isDollar />
                            <Input
                                className="referral-percent"
                                type="text"
                                valueType="percent"
                                name="BANK_BONUS_PERCENT"
                                value={data.BANK_BONUS_PERCENT}
                                handleParentChange={handleChangeInput}
                                viewMode={viewMode}
                                deleted={deleted}
                                decimals={2} />
                        </div>
                        <Input
                            className="Loan_column_item"
                            type="text"
                            valueType="float"
                            name="HSC_LIST_FEE"
                            label="Peak fee - auto"
                            tooltip='Total Fee - Referral - Credits + Bank Bonus'
                            tooltipPosition='down'
                            value={(hscTotalFee - referral - credits + bankBonus).toFixed(2)}
                            disabled
                            handleParentChange={handleChangeInput}
                            viewMode={viewMode}
                            onInputClick={data.HSC_APPROVED ? openHscPayments : null}
                            deleted={deleted}
                            decimals={2}
                            isDollar />
                        <div className='Loan_column_item'>
                            <Checkbox
                                text='Approved'
                                type={isUncheckable ? 'uncheckable' : 'checkable'}
                                isSelected={data.HSC_APPROVED}
                                handleClick={handleChangeInput}
                                name='HSC_APPROVED' />
                            <div className="Loan_column_timestamp-container">
                                <span className="Loan_timestamp">{data.HSC_APPROVED_INITIALS || '-'}</span>
                                {timestampDate && <span className="Loan_timestamp">{timestampDate}</span>}
                                {timestampHour && <span className="Loan_timestamp">{timestampHour}</span>}
                            </div>
                        </div>
                        <UploadFiles
                            classNames="Loan_column_item"
                            data={data}
                            viewMode={viewMode}
                            deleted={deleted}
                            handleChangeFile={handleChangeFile}
                            maxFilesAmount={closingStatementFile.length}
                            items={closingStatementFile}
                            droppable
                            />
                            <div>
                                <button 
                                    className="button-new" 
                                    style={{border: '1px solid rgb(144, 185, 237)', color: 'rgb(144, 185, 237)', background: "transparent", width: "auto", padding: "0px 16px"}} 
                                    onClick={printHscInvoice}>
                                        INVOICE &amp; WIRING INSTRUCTIONS
                                </button>
                            </div>
                    </div>
                </div>}
        </div>
        </React.Fragment>
    );
};

export default Loan;
